/* eslint-disable camelcase */
export const OVB_Blau = '#003366'; // mindin primary
export const OVB_Himbeer = '#CC0066'; // mind error

export const OVB_Ozean = '#006666'; // success1
export const OVB_Fruhling = '#8BBF18'; // success2

export const OVB_Sonne = '#FFCC33'; // secondary/accent
export const OVB_Purpur = '#663399'; // secondary/accent
export const OVB_Sky = '#00B7E5'; // secondary/accent
/* eslint-enable camelcase */
